export default {
    RARE: 'Rare',
    UNCOMMON: 'Uncommon',
    COMMON: 'Common',
    EVERYDAY: 'Everyday',

    LEGENDARY: 'Legendary',

    UNKNOWN: 'Unknown',
}